import { FC, useRef } from 'react';

import { DOT } from 'utils/constants/common';

import { Button, Cell, HSpacing, Text, TooltipHover, useBreakpoint, VSpacing } from '@hh.ru/magritte-ui';
import { ExclamationCircleOutlinedSize24 } from '@hh.ru/magritte-ui/icon';

import useTrls from 'hooks/translation/useTrls';

import { selectMultiCreationVacanciesAuctionInfo } from 'store/models/multiCreation';
import { useSelector } from 'store/utils';

const TrlKeys = {
    id: 'MultiCreationAuction.VacanciesTable.VacanciesTableBody.id',
    tooltipTitle: 'MultiCreationAuction.VacanciesTable.VacanciesTableBody.errorTooltip.title',
    tooltipText: 'MultiCreationAuction.VacanciesTable.VacanciesTableBody.errorTooltip.text',
};

export const VacancyInfo: FC<{ vacancyId: number; deleteButton?: JSX.Element }> = ({ vacancyId, deleteButton }) => {
    const currentVacanciesAuctionInfo = useSelector(selectMultiCreationVacanciesAuctionInfo)[vacancyId];
    const currentAuctionsToCreate = useSelector(({ multiCreation }) => multiCreation.auctionsToCreate[vacancyId]);

    const { name, areaName } = currentVacanciesAuctionInfo.vacancy;

    const { isMobile } = useBreakpoint();
    const trls = useTrls();
    const activatorRef = useRef(null);

    const content = (
        <>
            <Text maxLines={1} typography="subtitle-1-semibold">
                {name}
            </Text>
            <VSpacing default={4} />
            <Text maxLines={1} typography="label-3-regular" style="secondary">
                {trls(TrlKeys.id, [vacancyId])}
                <HSpacing default={4} />
                {DOT}
                <HSpacing default={4} />
                {areaName}
            </Text>
        </>
    );

    return !isMobile ? (
        <>
            <Cell
                right={
                    currentAuctionsToCreate.isCreationFailed ? (
                        <div>
                            <Button
                                ref={activatorRef}
                                mode="secondary"
                                style="negative"
                                hideLabel
                                icon={<ExclamationCircleOutlinedSize24 initialColor="negative" />}
                            />
                            <TooltipHover
                                activatorRef={activatorRef}
                                placement="right-center"
                                title={trls(TrlKeys.tooltipTitle)}
                            >
                                {trls(TrlKeys.tooltipText)}
                            </TooltipHover>
                        </div>
                    ) : undefined
                }
            >
                {content}
            </Cell>
        </>
    ) : (
        <Cell right={deleteButton}>{content}</Cell>
    );
};
